import React from "react";

function exportChatAuditToCSV(channelName, auditData, columnHeaders) {
  if (!auditData || Object.keys(auditData).length === 0) {
    alert("No data to export.");
    return;
  }

  let csvRows = [];

  // Create header row dynamically
  csvRows.push(columnHeaders.join(","));

  Object.entries(auditData).forEach(([channelId, messages]) => {
    messages.forEach((msg) => {
      const rowData = columnHeaders.map((header) => {
        switch (header) {
          case "Channel":
            return `"${channelName}"`;
          case "Employee Name":
            return `"${(msg.senderName || "").replace(/,/g, "")}"`;
          case "Employee ID":
            return `"${msg.senderId || ""}"`;
          case "Timestamp":
            return `"${new Date(msg.timestamp).toLocaleString()}"`;
          case "Message":
            if (msg.contentType === "image" || msg.contentType === "file") {
              return `"${msg.contentUrl?.[0]?.fileUrl || ""}"`;
            } else {
              return `"${(msg.content || "")
                .replace(/<[^>]*>/g, "")
                .replace(/\n/g, " ")
                .replace(/,/g, "")}"`;
            }
          default:
            return `""`; // empty if header is unknown
        }
      });

      csvRows.push(rowData.join(","));
    });
  });

  const csvContent = csvRows.join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", "chat_audit.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default exportChatAuditToCSV;
